import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ebb-please-contact',
  templateUrl: './please-contact.component.html',
  styleUrls: ['./please-contact.component.scss']
})
export class PleaseContactComponent implements OnInit {
  @Input() message: string;
  constructor() { }

  ngOnInit() {
  const errormessage =  this.getCookie("ebberrormessage");
  if(errormessage){
    this.message =errormessage;
    this.eraseCookie("ebberrormessage");
  }
    if(this.message == "" || this.message == undefined){
      this.message ="Please contact Customer Service at (877) 232-4300 or at info@EarthquakeBraceBolt.com.";
    }
  }
  private getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
private eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
}
